import Vue from 'vue'

Vue.filter('formatDate', function (value) {
  return new Date(value).toLocaleDateString().substring(0, 5)
})

Vue.filter('formatDateHeure', function (value) {
  return new Date(value).toLocaleString().substring(0, 18)
})

Vue.filter('pluralize', (text, count, addCount = true) => {
  return (addCount ? (count === 0 ? 'Aucun' : count || '') + ' ' : '') + text + (count > 1 ? 's' : '')
})

Vue.filter('truncateChars', function (text, limit) {
  if (text) {
    return (text.length > limit) ? text.substring(0, limit) + '\u2026' : text
  }
})

const numberFormat = new Intl.NumberFormat()
Vue.filter('formatNumeric', function (value) {
  let parsedValue = parseFloat(value)
  return Number.isFinite(parsedValue) ? numberFormat.format(parsedValue) : value
})
